import { connect } from "react-redux";
import Style from "../../../utility/Style";
import { Constants } from "../StateTags";

interface Props
{
    constants: Constants
}

function NodeStyles({ constants }: Props)
{
    return (
        <>
            {Object.entries(constants)
                .map(([id, constant]) =>
                    Object.entries(constant.style ?? {})
                        .map(([value, style]) =>
                            <Style key={value} name={`${id}_${value}`} style={style} />
                        )
                )
            }
        </>
    );
}

const mapStateToProps = (store: never) => ({
});
export default connect(mapStateToProps, {
})(NodeStyles);